import React from 'react';
import styled from 'styled-components';

const parseGradientText = (
  text,
  linearGradient = 'linear-gradient(90deg, #ff7e5f, #feb47b)'
) => {
  const regex = /\{\*(.*?)\*\}/g;
  const parts = [];
  let lastIndex = 0;
  let match = regex.exec(text);

  const GradientText = styled.span`
    background: ${linearGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  `;

  while (match !== null) {
    const preceding = text.slice(lastIndex, match.index);
    if (preceding) {
      parts.push(preceding.replace(/[\u2028\u2029\u00A0]/g, ' '));
    }

    parts.push(
      <GradientText key={match.index}>
        {match[1].replace(/[\u2028\u2029\u00A0]/g, ' ')}
      </GradientText>
    );

    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }

  const remaining = text.slice(lastIndex);
  if (remaining) {
    parts.push(remaining.replace(/[\u2028\u2029\u00A0]/g, ' '));
  }

  return parts;
};

export default parseGradientText;
